import { NavLink, Link } from 'react-router'
import Logo from '@/components/Logo'
import flagCa from '@/assets/flag-ca.svg'
import { useLanguage, type Lang } from '@/i18n/LanguageContext'
import { useT } from '@/i18n/useT'

export default function Nav() {
  const t = useT()
  const { lang, setLang } = useLanguage()

  const links = [
    { to: '/features', label: t.nav.features },
    { to: '/pricing', label: t.nav.pricing },
    { to: '/integrations', label: t.nav.integrations },
    { to: '/tools', label: t.nav.tools },
  ]

  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-start gap-2">
          <Logo className="h-7 w-auto" />
        </Link>

        <nav className="flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-[15px] font-medium transition-colors ${isActive ? 'text-brand-700' : 'text-ink-soft hover:text-ink'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {/* language toggle */}
          <div className="flex rounded border border-slate-200 overflow-hidden text-[13px] font-bold">
            {(['en', 'fr'] as Lang[]).map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                aria-pressed={lang === l}
                className={`px-2.5 py-1.5 uppercase transition-colors ${lang === l
                  ? 'bg-brand-600 text-white'
                  : 'text-ink-mute hover:text-ink bg-white'
                  }`}
              >
                {l}
              </button>
            ))}
          </div>
          <img
            src={flagCa}
            alt="Canadian payroll"
            title="Canadian payroll, all provinces"
            className="h-4 w-auto rounded-[2px] ring-1 ring-slate-200"
          />
          {/* <Link
            to="/login"
            className="rounded border border-slate-200 hover:border-brand-600 hover:text-brand-700 transition-colors text-ink text-[15px] font-semibold px-5 py-2.5"
          >
            {t.nav.login}
          </Link> */}

          <a
            href="https://v4app.simplepay.ca/"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded border border-slate-200 hover:border-brand-600 hover:text-brand-700 transition-colors text-ink text-[15px] font-semibold px-5 py-2.5"
          >
            {t.nav.login}
          </a>
        </div>
      </div>
    </header>
  )
}
